import { Routes, Route } from "@angular/router";
import { BaseRoutingFactory } from "./base-routing.factory";
import { ResetPasswordComponent } from "../components/authentication/components/reset-password/reset-password.component";
import { AuthenticationComponent } from "../components/authentication/components/authentication/authentication.component";
import { FinishRegisterComponent } from "../components/authentication/components/finish-register/finish-register.component";
import { LoginComponent } from "../components/authentication/components/login/login.component";
import { MailConfirmationComponent } from "../components/authentication/components/mail-confirmation/mail-confirmation.component";
import { MailVerificationComponent } from "../components/authentication/components/mail-verification/mail-verification.component";
import { PreRegisterComponent } from "../components/authentication/components/pre-register/pre-register.component";
import { RegisterComponent } from "../components/authentication/components/register/register.component";
import { HasValidURLTokenGuard } from "../guards/authentication/has-valid-url-token.guard";
import { RegistrationIsEnabledGuard } from "../guards/authentication/registration-enabled.guard";
import { I18nService } from "../services/i18nService";
import { inject } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

export class AuthenticationRoutingFactory extends BaseRoutingFactory {

    private readonly coreAuthenticationRoute: Routes = [
        {
            path: '',
            component: this.componentService.get(AuthenticationComponent),
            children: [
                {
                    path: '',
                    redirectTo: '/authentication/login',
                    pathMatch: 'full'
                },
                {
                    path: 'login',
                    component: this.componentService.get(LoginComponent),
                    title: () => this.translateService.instant("auth.login") + " | " + this.translateService.instant("xfound.portal.tabname"),
                },
                {
                    path: 'register',
                    component: this.componentService.get(RegisterComponent),
                    canActivate: [
                        this.componentService.get(HasValidURLTokenGuard),
                        this.componentService.get(RegistrationIsEnabledGuard),
                    ],
                    title: () => this.translateService.instant("register.register") + " | " + this.translateService.instant("xfound.portal.tabname")
                },
                {
                    path: 'finishregister',
                    component: this.componentService.get(FinishRegisterComponent),
                    canActivate: [this.componentService.get(HasValidURLTokenGuard)],
                    title: () => this.translateService.instant("register.register") + " | " + this.translateService.instant("xfound.portal.tabname")
                },
                {
                    path: 'preregister',
                    component: this.componentService.get(PreRegisterComponent),
                    canActivate: [this.componentService.get(RegistrationIsEnabledGuard)],
                    title: () => this.translateService.instant("auth.register") + " | " + this.translateService.instant("xfound.portal.tabname")
                },
                {
                    path: 'resetpassword',
                    component: this.componentService.get(ResetPasswordComponent),
                    canActivate: [this.componentService.get(HasValidURLTokenGuard)],
                    title: () => this.translateService.instant("auth.reset_password") + " | " + this.translateService.instant("xfound.portal.tabname")
                },
                {
                    path: 'mailverification',
                    component: this.componentService.get(MailVerificationComponent),
                    title: () => this.translateService.instant("auth.reset_password") + " | " + this.translateService.instant("xfound.portal.tabname")
                },
                {
                    path: 'mailconfirmation',
                    component: this.componentService.get(MailConfirmationComponent),
                }
            ]
        }
    ];

    public create(): Routes {
        const coreRoute = this.coreRoute;

        return coreRoute;
    }

    protected get coreRoute(): Routes {
        return this.coreAuthenticationRoute;
    }

    protected registerChild(coreRoute: Routes, route: Route): void {
        const formRoutes = coreRoute![0].children!;
        const foundIndex = formRoutes?.findIndex(formRoute => formRoute.path === route.path);
        if (foundIndex >= 0) {
            formRoutes[foundIndex] = route;
        }
        else {
            coreRoute![0].children!.push(route);
        }
    }
    
}